import React, { Component } from 'react';
import "./taggedImage.css";
import PortalModal from '../../alpineComponents/portalModal'
import { Link } from "react-router-dom";
import GoogleMap from './../googleMap'

export default class TaggedImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
        fullScreen: false,
        fullScreenReady:false
    };
  }

  componentDidMount = async() => {
    let latlng = this.props.latlng;
    this.setState({
      latlng:latlng
    })
  }

  onFullScreenImageLoad = () => {
    this.setState({
      onFullScreenImageLoaded:true
    })
  }

  onBackgroundImageLoad = () => {
    this.setState({
      onBackgroundImageLoaded:true
    })
  }

  activateFullScreen = () => {
    this.setState({
      onFullScreenImageLoaded:false,
      fullScreen:true
    },()=>{
      setTimeout(()=>{
        this.setState({
          fullScreenReady:true
        })
      },250)
    })
  }

  hideFullScreen = () => {
    this.setState({
      fullScreenReady:false
    },()=>{
      setTimeout(()=>{
        this.setState({
          fullScreen:false
        })
      },250)
    })
  }

  render() {
    let image = this.props.image;
    let backgroundImage = this.props.backgroundImage ? 'url('+this.props.backgroundImage+')' : null ;
    let targetImage = this.props.backgroundImage ? this.props.backgroundImage : image;
    let backgroundImageLoadedClass = "loaded";
    let fullScreenImageLoadedClass = "";
    if(this.props.backgroundImage){
      backgroundImageLoadedClass = ""
    }
    if(this.state.onBackgroundImageLoaded){
      backgroundImageLoadedClass = "loaded"
    }
    if(this.state.onFullScreenImageLoaded){
      fullScreenImageLoadedClass = "loaded"
    }
    let activeClass = "";
    let fullScreenReadyClass = "";
    if(this.state.fullScreen){
      activeClass = "active";
      if(this.state.fullScreenReady){
        fullScreenReadyClass = "ready"
      }
    }
    return (
      <div {...this.props} className={"tagged-image-overlay-container"} >
        {this.props.backgroundImage && <img className="tagged-image-background-preload" src={this.props.backgroundImage} onLoad={this.onBackgroundImageLoad} />}
        <img className={"tagged-image-original-image "+backgroundImageLoadedClass} src={image} style={{backgroundImage:backgroundImage}}  onClick={this.activateFullScreen} />
        <div className="tagged-image-tag-hover-icon" onClick={this.activateFullScreen} >
          <img src={'/images/tag-icon.png'} />
        </div>
        {this.state.fullScreen &&
          <PortalModal
            modalHidden={this.hideFullScreen}
            modalActive={this.state.fullScreen}
            content={
              <div className={"tagged-image-full-screen-container row active full-height full-width " +fullScreenReadyClass}>
                <img className={"tagged-image-background-preload"} src={targetImage} onLoad={this.onFullScreenImageLoad} />
                <h4 className="show-for-small tagged-image-overlay-container-title-sm white small-padding">{this.props.city}</h4>
                <div
                  className={"tagged-image-overlay-image "+fullScreenImageLoadedClass}
                  style={{backgroundImage:'url('+targetImage+')'}}>
                </div>
                <div
                  className="tagged-image-overlay-tag-container dark-grey-background" style={{backgroundColor:"#000",position:"relative"}}>
                    <h4 className="hide-for-small tagged-image-overlay-container-title white" style={{backgroundColor:"#000",position:"relative", zIndex:5, margin:'0px'}}>{this.props.city}</h4>
                    <div className="full-height full-width white-background" style={{position:"absolute", top:'0px'}}>
                      {this.props.latlng && <GoogleMap latlng={this.props.latlng} />}
                    </div>
                </div>
            </div>
            }
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/taggedImage/index.js